export const environment = {
    production: false,
    serviceAwsHostname: 'https://dev-services.e2tst.net/',
    serviceAwsApp: 'afs',
    serviceAwsParser: '?q.parser=lucene',
    servicePdfPath: 'https://efast2-filings-public.s3.amazonaws.com/dev',
    ngHostname: 'http://localhost:4200',
    recordsMax: '200',
    recordsMaxTotal: '5000',
    helpLink: '../../5500Search/help/help.html',
    AFSDDLink: '../../5500Search/dictionary/Form5500_Search_CSV_Data_Dictionary.txt',
    Form5500SeriesDDLink: 'https://www.dol.gov/agencies/ebsa/about-ebsa/our-activities/public-disclosure/foia/form-5500-datasets'
}